<template>
    <div>
        <Header />
        <WeeklyRanking />
        <div v-if="$store.state.hostName !== 'Q'">
            <Footer />
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import WeeklyRanking from '@/components/WeeklyRanking.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'WeeklyRankingView',

  components: {
    Header,
    WeeklyRanking,
    Footer
  }
}
</script>
